import controller from './successful.controller';
import '../student.less';

export default {
  controller,
  template: require('./successful.html')
};



// WEBPACK FOOTER //
// src/app/components/student/successful/successful.component.ts